export default [
  {
      title: 'Billing',
      icon: 'DollarSignIcon',
      children: [
        {
          title: 'Buy Credits',
          route: 'buy-credits',
        },
        {
          title: 'Transaction History',
          route: 'transaction-history',
        },
      ],
    }
  ];